module.exports = __webpack_public_path__ + "static/img/practice-bg.8893debf.png";